<div class="footer-links-container">
  <a [yatExternalLink]="TERMS_OF_SERVICE_URL$ | async" yat-link>{{ 'terms' | legalWording: staticKeys | async }}</a
  ><a [yatExternalLink]="PRIVACY_POLICY_URL$ | async" yat-link>{{ 'privacy' | legalWording: staticKeys | async }}</a>
  <a [href]="IMPRINT_URL" yat-link>{{ 'legalNotice' | legalWording: staticKeys | async }}</a>
  <ng-content></ng-content>
</div>
<div class="mt-2">
  <p class="footer-company no-skeleton">&copy; {{ currentYear }} Yatta Solutions GmbH</p>
</div>
